export default __webpack_public_path__ + "static/media/warning--accident-area--g3.8f08b131.png";